import * as React from 'react';

import { round } from 'lodash';

const PRECISION = 2;

export const CUFT: React.FC<{ value: number }> = ({ value }) => <>{round(value, PRECISION)}</>;
